if (!customElements.get('custom-subscription')) {
  customElements.define(
    'custom-subscription',
    class CustomSubscription extends HTMLElement {
      constructor() {
        super();
        this.subscriptionData = {};
        this.eventListeners = new Map();

        this.step1 = this.querySelector('.js-subscription-step-box');
        this.step2 = this.querySelectorAll('.js-subscription-step-name');
        this.step3 = this.querySelector('.js-step-size');
        // this.step4 = this.querySelector('.js-subscription-step-breed');
        this.step5 = this.querySelector('.js-step-dob');
        this.step6 = this.querySelector('.js-step-allergies');
        this.step7 = this.querySelector('.js-step-email');
        this.step8 = this.querySelector('.js-step-plan');
        this.step9 = this.querySelector('.js-step-extra');
        this.allSteps = this.querySelectorAll('.js-subscription-item');

        this.bundleCollectionSize = '';
        this._bundleCollectionSize = '';
        this.planVariantId = '';
        this.extraProductId = '';
        this.sellingPlanId = '';
        this.addGift = "false";
        this.showAllergyURLParam = false;
        this.selectedExtraProductIds = new Set();

        // preserve previous behaviour in theme editor: do not mutate URL/history in design mode
        if(window.Shopify.designMode != true) {
          // window.history.replaceState({}, document.title, window.location.pathname);
        }
        
        this.urlObject = new URL(window.location.href);

        // Initialize or persist an utm_id that will be appended to URL and included in subscriptionData
        // so analytics can tie steps and input values together.
        // this.initUtmId();

        if(window.Shopify.designMode != true) {
          // keep tracking of step in URL (but DO NOT set utm_source)
          this.urlObject.searchParams.set('step', 1);
          // other initial tracking for step1 box selection is preserved
          if(this.step1 && this.step1.querySelector('.js-box-type.box-active') && this.step1.querySelector('.js-box-type.box-active').getAttribute('data-current-sub')) {
            let step1ParamKey = this.step1.getAttribute('data-url-tracking-key') || 'box_type';
            this.urlObject.searchParams.set(step1ParamKey, this.step1.querySelector('.js-box-type.box-active').getAttribute('data-current-sub'));
          }
          history.pushState(null, '', this.urlObject);
        }
        
        this.subscriptionSteps();
        this.currentQuiz = this.step1.querySelector('.js-box-type.box-active')?.getAttribute('data-url-param');
      }

      /* -------------------------
         UTM / Session handling
         ------------------------- */
      initUtmId() {
        // Prefer utm_id in URL -> sessionStorage -> create new
        if (window.Shopify.designMode == true) {
          this.utmId = this.urlObject.searchParams.get('utm_id') || sessionStorage.getItem('subscription_utm_id') || null;
          if (this.utmId) {
            // keep it in subscriptionData for design preview if desired
            this.subscriptionData['utm_id'] = this.utmId;
          }
          return;
        }

        let existingUtmId = this.urlObject.searchParams.get('utm_id') || sessionStorage.getItem('subscription_utm_id');

        if (existingUtmId) {
          this.utmId = existingUtmId;
        } else {
          // generate a reasonably unique id (timestamp + random)
          this.utmId = `sub-${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
          sessionStorage.setItem('subscription_utm_id', this.utmId);
        }

        // Always include utm_id in url params for analytics
        if (this.utmId) {
          this.urlObject.searchParams.set('utm_id', this.utmId);
          this.subscriptionData['utm_id'] = this.utmId;
        }
      }

      handleProgressBar(step) {
        let progressBar = this.querySelector('.js-progress-bar-width');
        let totalBlocks = progressBar.getAttribute('data-block-count');
        let widthPercent = (100 * step) / totalBlocks;
        progressBar.style.width = `${widthPercent}%`;

        let progressText = this.querySelector('.js-progress-text');
        progressText.innerHTML = `Step ${step}/${totalBlocks}`;
      }

      showStep(stepNumber) {
        this.allSteps.forEach((step) => {
          step.classList.add('hide');
          step.classList.remove('active_div');
        });

        const nextStep = this.querySelector(`.js-sub-step--${stepNumber}`);
        if (nextStep) {
          nextStep.classList.remove('hide');
          nextStep.classList.add("active_div");
        }

        if(nextStep.classList.contains("js-step-size")) {
          window.setGridHeight('.item_boxs.custom_image .box_item');
        }

        if(nextStep.classList.contains("js-subscription-step-box")) {
          window.setGridHeight('.js-box-type');
        }

        if(nextStep.classList.contains("js-step-plan")) {
          window.setGridHeight('.js-subscription-plan .subscription-step-plan-product');
        }

        if(nextStep.classList.contains("js-step-allergies")) {
          this.showAllergyURLParam = true;
          let selectedAllergies = nextStep.querySelectorAll('.js-allergy-checkbox');
          let paramKey = nextStep.getAttribute('data-url-tracking-key') || "allergies";
          
          let selectedAllergiesValue = '';
          
          if (selectedAllergies.length > 0) {
            selectedAllergiesValue = Array.from(selectedAllergies)
              .filter(allergy => allergy.checked)
              .map(allergy => allergy.value)
              .join(', ');
          }
          this.updateURLParam(paramKey, selectedAllergiesValue);
        }

        // always update step param when showing a new step (keeps analytics in sync)
        this.updateURLParamStep(stepNumber);
      }

      addNavigationHandlers(stepElement, propKey) {
        let isMobile = window.matchMedia('(max-width: 699px)').matches;
        let nextBtn = stepElement?.querySelector('.js-next-button');
        let prevBtn = stepElement?.querySelector('.js-prev-button');
        let skipBtn =  isMobile ? stepElement?.querySelector('.js-mob-skip-button') : stepElement?.querySelector('.js-skip-button');
        let nextStepNumber = nextBtn?.getAttribute('data-next');
      
        if (nextBtn) {
          if (this.eventListeners.has(nextBtn)) {
            nextBtn.removeEventListener('click', this.eventListeners.get(nextBtn));
          }
          const handleNextClick = () => {
            this.showStep(nextStepNumber);
            this.handleProgressBar(parseInt(nextStepNumber));
            this.updateURLParamStep(nextStepNumber);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          };
          nextBtn.addEventListener('click', handleNextClick);
          this.eventListeners.set(nextBtn, handleNextClick);
        }
      
        if (prevBtn) {
          if (this.eventListeners.has(prevBtn)) {
            prevBtn.removeEventListener('click', this.eventListeners.get(prevBtn));
          }
          const handlePrevClick = () => {
            let prevStepNumber = prevBtn.getAttribute('data-previous');
            this.showStep(prevStepNumber);
            this.handleProgressBar(parseInt(prevStepNumber));
            this.updateURLParamStep(prevStepNumber);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          };
          prevBtn.addEventListener('click', handlePrevClick);
          this.eventListeners.set(prevBtn, handlePrevClick);
        }

        if (skipBtn) {
          if (this.eventListeners.has(skipBtn)) {
            skipBtn.removeEventListener('click', this.eventListeners.get(skipBtn));
          }
          const handleSkipClick = () => {
            if(propKey) this.subscriptionData[`${propKey}`] = "";
            this.showStep(nextStepNumber);
            this.handleProgressBar(parseInt(nextStepNumber));
            this.updateURLParamStep(nextStepNumber);
            this.removeFieldValues(stepElement);

            let paramKey = skipBtn.getAttribute('data-url-tracking-key');
            if(paramKey) this.updateURLParam(paramKey, null);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          };
          skipBtn.addEventListener('click', handleSkipClick);
          this.eventListeners.set(skipBtn, handleSkipClick);
        }
      }

      removeFieldValues(stepElement) {
        if(stepElement.classList.contains('js-subscription-step-name')) {
          let inputQuizField = stepElement.querySelector('.js-input-quiz-field');
          let nextStepBtn = stepElement.querySelector('.js-next-button');
          if(inputQuizField) inputQuizField.value = "";
          if(nextStepBtn) nextStepBtn.disabled = true;
        }
        if(stepElement.classList.contains('js-step-dob')) {
          let birthDay = stepElement.querySelector('.js-dog-birthday');
          let birthMonth = stepElement.querySelector('.js-dog-birthmonth');
          let birthYear = stepElement.querySelector('.js-dog-birthyear');
          let nxtStepBtn = stepElement.querySelector('.js-next-button');
          if(birthDay) birthDay.value = "Day";
          if(birthMonth) birthMonth.value = "Month";
          if(birthYear) birthYear.value = "Year";
          if(nxtStepBtn) nxtStepBtn.disabled = true;
        }
      }

      updateURLParam(key, value) {
        if(window.Shopify.designMode == true) return;
        if(key && value) {
          this.urlObject.searchParams.set(key, value);
        } 
        else if (key && (value === "" || value === null)) {
          this.urlObject.searchParams.delete(key);
        }
        // ensure utm_id persists on every update
        if (this.utmId) {
          this.urlObject.searchParams.set('utm_id', this.utmId);
          // also keep it in subscriptionData
          this.subscriptionData['utm_id'] = this.utmId;
        }
        history.pushState(null, '', this.urlObject);
      }

      updateURLParamStep(stepNumber) {
        if(window.Shopify.designMode == true) return;
        this.urlObject.searchParams.set('step', stepNumber);
        if (this.utmId) this.urlObject.searchParams.set('utm_id', this.utmId);
        history.pushState(null, '', this.urlObject);
      }

      subscriptionSteps() {
        this.initialRedirection();
        this.boxType();
        this.quizInputField();
        this.boxSize();
        // this.breedType();
        this.dateOfBirth();
        this.dogfAllergies();
        this.emailField();
        this.updatePlans();
        this.selectExtra();
      }

      set bundleCollectionSize(value) {
        if (this._bundleCollectionSize !== value) {
          this._bundleCollectionSize = value;
          this.updatePlans();
        }
      }
      
      get bundleCollectionSize() {
        return this._bundleCollectionSize;
      }

      initialRedirection() {
        const storedValue = sessionStorage.getItem("theme:subscription-selection");
      
        if (storedValue) {
          const selectedBox = this.step1.querySelector(`[data-current-sub="${storedValue}"]`);
          console.log("storedValue>>",storedValue);
          console.log("selectedBox>>",selectedBox);
          const nextStepBtn = this.step1.querySelector('.js-next-button');
          let paramKey = this.step1.getAttribute('data-url-tracking-key') || 'box_type';
          let paramValue = selectedBox.getAttribute('data-url-tracking-value') || selectedBox.getAttribute('data-current-sub');
      
          if (selectedBox && nextStepBtn) {
            selectedBox.classList.add('box-active');
            const boxes = this.step1.querySelectorAll('.js-box-type');
            boxes.forEach(box => {
              if (box !== selectedBox) box.classList.remove('box-active');
            });
            this.updateURLParam(paramKey, paramValue);
            nextStepBtn.disabled = false;
            this.addNavigationHandlers(this.step1);
            // nextStepBtn.click();
            sessionStorage.removeItem("theme:subscription-selection");
          }
        }
      }

      boxType() {
        if (!this.step1) return;

        let boxes = this.step1.querySelectorAll('.js-box-type');
        let nextStepBtn = this.step1.querySelector('.js-next-button');
        let urlKey = this.step1.getAttribute('data-url-tracking-key') || 'box_type';
        
        if (!boxes.length || !nextStepBtn) return;
        
        if(boxes.length > 0) {
          boxes.forEach(box => {
            box.addEventListener('click', (e) => {
              if(box.getAttribute("href") == "#"){
                e.preventDefault();
                let paramValue = box.getAttribute('data-url-tracking-value') || box.getAttribute('data-current-sub');
                this.updateURLParam(urlKey, paramValue);
              }
              else {
                let currentSelection = box.getAttribute('data-current-sub');
                sessionStorage.setItem("theme:subscription-selection", currentSelection);
              }
              boxes.forEach(b => b.classList.remove('box-active'));
              box.classList.add('box-active');
              
              let anyActive = Array.from(boxes).some(box => box.classList.contains('box-active'));
              nextStepBtn.disabled = !anyActive;
            })
          })
        }

        this.addNavigationHandlers(this.step1);
        window.setGridHeight('.js-box-type');
      }

      quizInputField() {
        if (this.step2.length < 1) return;

        this.step2.forEach((currStep) => {
          let inputQuizField = currStep.querySelector('.js-input-quiz-field');
          let lineItemProp = currStep.getAttribute('data-line-item-property') || 'Quiz field'; 
          let nextStepBtn = currStep.querySelector('.js-next-button');
          let addToBoxBtn = currStep.querySelector('.js-add-to-box');
          let urlKey = currStep.getAttribute('data-url-tracking-key') || 'quiz_field';

          if (!inputQuizField || (!nextStepBtn && !addToBoxBtn)) return;
      
          this.eventListeners.forEach((listener, el) => {
            if (!document.contains(el)) {
              el.removeEventListener('input', listener);
              this.eventListeners.delete(el);
            }
          });

          if (this.eventListeners.has(inputQuizField)) {
            inputQuizField.removeEventListener('input', this.eventListeners.get(inputQuizField));
          }

          const handleInput = () => {
            let quizValue = inputQuizField.value.trim();
            if (nextStepBtn) nextStepBtn.disabled = !quizValue;
            if (addToBoxBtn) addToBoxBtn.disabled = !quizValue;
            this.subscriptionData[`${lineItemProp}`] = quizValue;
            if (quizValue !== "") {
              this.updateURLParam(urlKey, quizValue);
            }
            else {
              this.updateURLParam(urlKey, null);
            }
          };

          inputQuizField.addEventListener('input', handleInput);
          this.eventListeners.set(inputQuizField, handleInput);
        
          this.addNavigationHandlers(currStep, lineItemProp);
          if (addToBoxBtn) {
            this.addSubscriptionToCart(addToBoxBtn);
          }
        })
      
        // let dogNameField = this.step2.querySelector('.js-dog-name-field');
        // let nextStepBtn = this.step2.querySelector('.js-next-button');
        // let addToBoxBtn = this.step2.querySelector('.js-add-to-box');
        // let urlKey = this.step2.getAttribute('data-url-tracking-key') || 'name';
      
        // if (!dogNameField || (!nextStepBtn && !addToBoxBtn)) return;
      
        // this.eventListeners.forEach((listener, el) => {
        //   if (!document.contains(el)) {
        //     el.removeEventListener('input', listener);
        //     this.eventListeners.delete(el);
        //   }
        // });
      
        // if (this.eventListeners.has(dogNameField)) {
        //   dogNameField.removeEventListener('input', this.eventListeners.get(dogNameField));
        // }
      
        // const handleInput = () => {
        //   let pupsName = dogNameField.value.trim();
        //   if (nextStepBtn) nextStepBtn.disabled = !pupsName;
        //   if (addToBoxBtn) addToBoxBtn.disabled = !pupsName;
        //   this.subscriptionData["Pup's Name"] = pupsName;
        //   if (pupsName !== "") {
        //     this.updateURLParam(urlKey, pupsName);
        //   }
        //   else {
        //     this.updateURLParam(urlKey, null);
        //   }
        // };
      
        // dogNameField.addEventListener('input', handleInput);
        // this.eventListeners.set(dogNameField, handleInput);
      
        // this.addNavigationHandlers(this.step2);
        // if (addToBoxBtn) {
        //   this.addSubscriptionToCart(addToBoxBtn);
        // }
      }

      boxSize() {
        if (!this.step3) return;
      
        let sizeBoxes = this.step3.querySelectorAll('.js-bundle-size');
        let nextStepBtn = this.step3.querySelector('.js-next-button');
        let subscriptionPlans = this.step8?.querySelectorAll('.js-subscription-plan') || [];
        let step9Btn = this.step8?.querySelector('.js-next-button');
        let addToBoxBtn = this.step3.querySelector('.js-add-to-box');
        let paramKey = this.step3.getAttribute('data-url-tracking-key') || "size";
      
        if (!sizeBoxes.length || (!nextStepBtn && !addToBoxBtn)) return;
      
        this.eventListeners.forEach((listener, el) => {
          if (!document.contains(el)) {
            el.removeEventListener('click', listener);
            this.eventListeners.delete(el);
          }
        });
      
        sizeBoxes.forEach((box) => {
          if (this.eventListeners.has(box)) {
            box.removeEventListener('click', this.eventListeners.get(box));
          }
      
          const handleClick = () => {
            sizeBoxes.forEach((boxItem) => boxItem.classList.remove('size-box-active'));
            box.classList.add('size-box-active');
      
            let boxSizeValue = box.querySelector('.js-box-size-value');
            this.bundleCollectionSize = box.getAttribute('data-bundle-size');
      
            let boxName = boxSizeValue?.querySelector('.box_title')?.innerHTML || '';
            let boxWeight = boxSizeValue?.querySelector('.box_subtext')?.innerHTML || '';
            if(boxWeight) {
              this.subscriptionData["Size"] = `${boxName} | ${boxWeight}`.trim();
            }
            else {
              this.subscriptionData["Size"] = `${boxName}`.trim();
            }
            let paramValue = box.getAttribute('data-url-tracking-value');
            this.updateURLParam(paramKey, paramValue);
      
            let anyActive = Array.from(sizeBoxes).some(box => box.classList.contains('size-box-active'));
            if (nextStepBtn) nextStepBtn.disabled = !anyActive;
            if (addToBoxBtn) addToBoxBtn.disabled = !anyActive;
      
            subscriptionPlans.forEach((plan) => {
              plan.classList.remove('plan-selected');
            });
      
            if (step9Btn && !step9Btn.disabled) step9Btn.disabled = true;
          };
      
          box.addEventListener('click', handleClick);
          this.eventListeners.set(box, handleClick);
        });
      
        this.addNavigationHandlers(this.step3);
        if (addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn);
        }
      }

      // breedType() {
      //   if (!this.step4) return;
      
      //   let breedTypeField = this.step4.querySelector('.js-breed-type-field');
      //   let nextStepBtn = this.step4.querySelector('.js-next-button');
      //   let addToBoxBtn = this.step4.querySelector('.js-add-to-box');
      //   let paramKey = this.step4.getAttribute('data-url-tracking-key') || "breed";
      
      //   if (!breedTypeField || (!nextStepBtn && !addToBoxBtn)) return;
      
      //   if (this.eventListeners.has(breedTypeField)) {
      //     breedTypeField.removeEventListener('input', this.eventListeners.get(breedTypeField));
      //   }
      
      //   const handleBreedInput = () => {
      //     const breedValue = breedTypeField.value.trim();
      //     if (breedValue !== "") {
      //       this.subscriptionData["Breed Type"] = breedValue;
      //       if (nextStepBtn) nextStepBtn.removeAttribute('disabled');
      //       this.updateURLParam(paramKey, breedValue);
      //     } else {
      //       if (nextStepBtn) nextStepBtn.setAttribute('disabled', 'true');
      //       this.updateURLParam(paramKey, null);
      //     }
      //   };
      
      //   breedTypeField.addEventListener('input', handleBreedInput);
      //   this.eventListeners.set(breedTypeField, handleBreedInput);
      
      //   this.addNavigationHandlers(this.step4, "Breed Type");
      
      //   if (addToBoxBtn) {
      //     this.addSubscriptionToCart(addToBoxBtn);
      //   }
      // }

      dateOfBirth() {
        if (!this.step5) return;
      
        let dobDayField = this.step5.querySelector('.js-dog-birthday');
        let dobMonthField = this.step5.querySelector('.js-dog-birthmonth');
        let dobYearField = this.step5.querySelector('.js-dog-birthyear');
        let nextStepBtn = this.step5.querySelector('.js-next-button');
        let addToBoxBtn = this.step5.querySelector('.js-add-to-box');
        let paramKey = this.step5.getAttribute('data-url-tracking-key');
      
        if (!dobDayField || !dobMonthField || !dobYearField || (!nextStepBtn && !addToBoxBtn)) return;
      
        const validateDOB = () => {
          let dobDay = dobDayField.value.trim();
          let dobMonth = dobMonthField.value.trim();
          let dobYear = dobYearField.value.trim();
      
          if (dobDay !== 'Day' && dobMonth !== 'Month' && dobYear !== 'Year') {
            this.subscriptionData["Dog's Dob"] = `${dobDay}-${dobMonth}-${dobYear}`;
            if (nextStepBtn) nextStepBtn.removeAttribute('disabled');
            this.updateURLParam(paramKey, `${dobDay}-${dobMonth}-${dobYear}`);
          } else {
            if (nextStepBtn) nextStepBtn.setAttribute('disabled', 'true');
            this.updateURLParam(paramKey, null);
          }
        };
      
        [dobDayField, dobMonthField, dobYearField].forEach(field => {
          if (this.eventListeners.has(field)) {
            field.removeEventListener('change', this.eventListeners.get(field));
          }
      
          field.addEventListener('change', validateDOB);
          this.eventListeners.set(field, validateDOB);
        });
      
        validateDOB();
      
        this.addNavigationHandlers(this.step5, "Dog's Dob");
        if (addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn);
        }
      }

      dogfAllergies() {
        if (!this.step6) return;
        
        let allergyCheckboxes = this.step6.querySelectorAll('.js-allergy-checkbox');
        let nextStepBtn = this.step6.querySelector('.js-next-button');
        let addToBoxBtn = this.step6.querySelector('.js-add-to-box');
        let paramKey = this.step6.getAttribute('data-url-tracking-key') || "allergies";
        
        if (!allergyCheckboxes.length || (!nextStepBtn && !addToBoxBtn)) return;
        
        let handleAllergyChange = (event) => {
          let changedCheckbox = event ? event.target : null;
          
          let noAllergyCheckbox = this.step6.querySelector('.js-no-allergy-checkbox');
          
          if (changedCheckbox && changedCheckbox.classList.contains('js-no-allergy-checkbox')) {
            if (changedCheckbox.checked) {
              allergyCheckboxes.forEach(checkbox => {
                if (!checkbox.classList.contains('js-no-allergy-checkbox')) {
                  checkbox.checked = false;
                }
              });
            }
          } else if (changedCheckbox) {
            if (changedCheckbox.checked && noAllergyCheckbox) {
              noAllergyCheckbox.checked = false;
            }
          }
          
          let selectedAllergies = Array.from(allergyCheckboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value)
            .join(', ');
          
          this.subscriptionData["Allergies"] = selectedAllergies;
          if(this.showAllergyURLParam) {
            this.updateURLParam(paramKey, selectedAllergies);
          }
        };
        
        allergyCheckboxes.forEach(checkbox => {
          if (this.eventListeners.has(checkbox)) {
            checkbox.removeEventListener('change', this.eventListeners.get(checkbox));
          }
          
          checkbox.addEventListener('change', handleAllergyChange);
          this.eventListeners.set(checkbox, handleAllergyChange);
        });
        
        handleAllergyChange();
        
        this.addNavigationHandlers(this.step6);
        
        if (addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn);
        }
      }

      emailField() {
        if (!this.step7) return;
      
        let emailField = this.step7.querySelector('.js-subscription-email-field');
        let newsletterCheckbox = this.step7.querySelector('.js-newsletter-checkbox');
        let nextStepBtn = this.step7.querySelector('.js-next-button');
        let addToBoxBtn = this.step7.querySelector('.js-add-to-box');
        let paramKey = this.step7.getAttribute('data-url-tracking-key') || "email";
      
        if (!emailField || !newsletterCheckbox || (!nextStepBtn && !addToBoxBtn)) return;
      
        const handleEmailInput = () => {
          let email = emailField.value.trim();
          let isValid = this.validateEmail(email);
          if (nextStepBtn) nextStepBtn.disabled = !isValid;
          if (addToBoxBtn) addToBoxBtn.disabled = !isValid;
          this.subscriptionData["Email"] = email;
          if(isValid) {
            this.updateURLParam(paramKey, email);
          }
          else {
            this.updateURLParam(paramKey, null);
          }
        };

        this.subscriptionData["Newsletter subscribed"] = newsletterCheckbox.checked;
        const handleNewsletterChange = () => {
          this.subscriptionData["Newsletter subscribed"] = newsletterCheckbox.checked;
        };
      
        if (!this.eventListeners.has(emailField)) {
          emailField.addEventListener('input', handleEmailInput);
          this.eventListeners.set(emailField, handleEmailInput);
        }
      
        if (!this.eventListeners.has(newsletterCheckbox)) {
          newsletterCheckbox.addEventListener('change', handleNewsletterChange);
          this.eventListeners.set(newsletterCheckbox, handleNewsletterChange);
        }
      
        this.addNavigationHandlers(this.step7);
      
        if (addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn);
        }
      }

      validateEmail(email) {
        let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
      }
      
      submitSubscribeEmail() {
        let getEmail = this.subscriptionData["Email"];
        let action = '/contact?';
        let locale = this.currentQuiz;
        // if(this.currentQuiz == "subscription-puppy") {
        //   locale = 'Puppy';
        // }
        // else if(this.currentQuiz == "subscription-chewer") {
        //   locale = 'Chewer';
        // }
        // else if(this.currentQuiz == "subscription-combo") {
        //   locale = 'Combo';
        // }
        // else {
        //   locale = 'Regular';
        // }
        
        const isFrenchSite =
          window.location.hostname.includes("fr.") ||
          window.location.pathname.toLowerCase().startsWith("/fr");

        locale = isFrenchSite ? locale + "-FR" : locale + "-EN";
      
        let formData = new URLSearchParams();
        formData.append('form_type', 'customer');
        formData.append('utf8', '✓');
        formData.append('contact[email]', getEmail);
        formData.append('contact[tags]', 'newsletter');
        formData.append('contact[tags]', locale);
        // ensure utm_id is attached to tags or data if desired by marketing team
        if (this.utmId) {
          formData.append('contact[tags]', locale + ',' + this.utmId);
        }
      
        fetch(action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: formData.toString()
        })
        .then(response => response.text())
        .then(responseText => {
          console.log(responseText);
        })
        .catch(error => {
          console.error('Request failed:', error);
        });
      }

      updatePlans() {
        if (!this.step8) return;
        
        let subscriptionPlans = this.step8.querySelectorAll('.js-subscription-plan');
        let popularPlanBtn = this.step8.querySelector('.js-popular-plan-btn');        
        let nextStepBtn = this.step8.querySelector('.js-next-button');
        let addToBoxBtn = this.step8.querySelector('.js-add-to-box');
        let paramKey = this.step8.getAttribute('data-url-tracking-key') || "plan";

        if (!subscriptionPlans.length || (!nextStepBtn && !addToBoxBtn)) return;
    
        subscriptionPlans.forEach((plan) => {
          let planCollectionSize = plan.getAttribute('data-size');
          
          if (planCollectionSize !== this.bundleCollectionSize) {
              plan.classList.add('hide');
          } else {
              plan.classList.remove('hide');
          }
  
          if (this.eventListeners.has(plan)) {
              plan.removeEventListener('click', this.eventListeners.get(plan));
          }
  
          const handlePlanClick = () => {
            let planId = plan.getAttribute('data-plan-id');
            let sellingPlan = plan.getAttribute('data-selling-plan');
            this.planVariantId = planId;
            this.sellingPlanId = sellingPlan;

            subscriptionPlans.forEach((subPlan) => subPlan.classList.remove('plan-selected'));
            plan.classList.add('plan-selected');

            let isGiftAdded = plan.getAttribute('data-gift-available');
            this.addGift = isGiftAdded;

            let anyActive = Array.from(subscriptionPlans).some(plan => plan.classList.contains('plan-selected'));
            if(nextStepBtn) nextStepBtn.disabled = !anyActive;
            if(addToBoxBtn) addToBoxBtn.disabled = !anyActive;
            let paramValue = plan.getAttribute('data-plan-name');
            if(paramKey && paramValue) this.updateURLParam(paramKey, paramValue);

            // also store variant id and selling plan id in subscriptionData for clearer analytics
            this.subscriptionData['plan_variant_id'] = this.planVariantId || '';
            this.subscriptionData['selling_plan_id'] = this.sellingPlanId || '';
          };
  
          plan.addEventListener('click', handlePlanClick);
          this.eventListeners.set(plan, handlePlanClick);
        });
    
        this.addNavigationHandlers(this.step8);
        if(addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn); 
        }
      }

      selectExtra() {
        if (!this.step9) return;
        
        let extraProducts = this.step9.querySelectorAll('.js-extra-product-container');
        let nextStepBtn = this.step9.querySelector('.js-next-button');
        let addToBoxBtn = this.step9.querySelector('.js-add-to-box');
        let paramKey = this.step9.getAttribute('data-url-tracking-key') || "extra_product";

        if(extraProducts.length > 0) {
          extraProducts.forEach((product) => {
            const handleProductClick = () => {
              let productId = product.getAttribute('data-extra-product-id');
              let productName = product.getAttribute('data-extra-product-name');
              let productSellingPlan = product.getAttribute('data-selling-plan') || '';

              let key = productSellingPlan && productSellingPlan.trim() !== '' ? `${productId}:${productSellingPlan}` : productId;
  
              if (this.selectedExtraProductIds.has(key)) {
                product.classList.remove('selected-extra-product');
                this.selectedExtraProductIds.delete(key);
              } else {
                product.classList.add('selected-extra-product');
                this.selectedExtraProductIds.add(key);
              }

              let selectedExtraProducts = Array.from(extraProducts)
                .filter(box => {
                  let pid = box.getAttribute('data-extra-product-id');
                  let plan = box.getAttribute('data-selling-plan') || '';
                  let key = plan.trim() !== '' ? `${pid}:${plan}` : pid;
                  return this.selectedExtraProductIds.has(key);
                })
                .map(box => box.getAttribute('data-extra-product-name'))
                .join(', ');

              let anyActive = Array.from(extraProducts).some(box => box.classList.contains('selected-extra-product'));
               const t = (window.themeTranslations && window.themeTranslations.subscription) ? window.themeTranslations.subscription : {
                checkout: "CHECKOUT",
                skip_and_checkout: "SKIP AND CHECKOUT"
              };
              if(nextStepBtn) nextStepBtn.disabled = !anyActive; 
              if (addToBoxBtn) {
                   addToBoxBtn.innerHTML = anyActive ? (t.checkout || "CHECKOUT") : (t.skip_and_checkout || "SKIP AND CHECKOUT");
              }
              this.updateURLParam(paramKey, selectedExtraProducts);

              // store selected extra product ids & names in subscriptionData for analytics
              this.subscriptionData['extra_products'] = selectedExtraProducts;
            };
        
            if (this.eventListeners.has(product)) {
              product.removeEventListener('click', this.eventListeners.get(product));
            }
        
            product.addEventListener('click', handleProductClick);
            this.eventListeners.set(product, handleProductClick);
          });
        }
      
        this.addNavigationHandlers(this.step9);
        if(addToBoxBtn) {
          this.addSubscriptionToCart(addToBoxBtn); 
        }
      }

      async getCartData() {
        let cart = await fetch('/cart.js').then(res => res.json());
        return cart;
      }

      addSubscriptionToCart(addToBoxBtn) {
        if (this.eventListeners.has(addToBoxBtn)) {
          addToBoxBtn.removeEventListener('click', this.eventListeners.get(addToBoxBtn));
        }
      
        const handleClick = async () => {
          let cartData = await this.getCartData();

          // ensure utm_id persists in payload
          if (this.utmId) this.subscriptionData['utm_id'] = this.utmId;
          this.subscriptionData['_subscription_product'] = 'true';
try {
  this.subscriptionData['_gift_eligible'] = this.addGift == "true" ? 'true' : 'false';
  let currentUrl = window.location.href.toLowerCase();
  this.subscriptionData['_gift_type'] = currentUrl.includes('chewer') ? 'durable' : 'regular';
} catch(e) {
  this.subscriptionData['_gift_eligible'] = 'false';
  this.subscriptionData['_gift_type'] = 'regular';
}
          let items = [
            {
              'id': this.planVariantId,
              'quantity': 1,
              'selling_plan': this.sellingPlanId,
              'properties': this.subscriptionData
            }
          ];
      
          if (this.selectedExtraProductIds && this.selectedExtraProductIds.size > 0) {
            this.selectedExtraProductIds.forEach((id) => {
              if (id.includes(':')) {
                let [productId, sellingPlan] = id.split(':');
                items.push({
                  id: productId,
                  quantity: 1,
                  selling_plan: sellingPlan
                });
              } else {
                items.push({
                  id: id,
                  quantity: 1
                });
              }
            });
          }
      
try {
  let currentUrl = window.location.href.toLowerCase();
  let giftElement = currentUrl.includes('chewer')
    ? this.querySelector('.js-sub-free-gift-durable')
    : this.querySelector('.js-sub-free-gift');

  if (giftElement && this.addGift == "true") {
    let giftProductId = parseInt(giftElement.getAttribute('data-gift-id'), 10);
    let giftType = giftElement.getAttribute('data-gift-type') || 'regular';
    let isGiftAlreadyInCart = cartData.items.some(item => item.variant_id === giftProductId);
    if (giftProductId && !isGiftAlreadyInCart) {
      items.push({
        'id': giftProductId,
        'quantity': 1,
        'properties': {
          '_subscription_free_gift': 'true',
          '_free_gift_type': giftType
        }
      });
    }
  }
} catch(e) {
  console.error('Free gift add error:', e);
}
      
          let formData = { 'items': items };
      
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            });
      
            const data = await response.json();
            const isFrenchSitecart =
              window.location.hostname.includes("fr.") ||
              window.location.pathname.toLowerCase().startsWith("/fr");
            window.location.href = isFrenchSitecart ? "/fr/cart" : "/cart";
          } catch (error) {
            console.error('Error adding to cart:', error);
          }

          this.submitSubscribeEmail();
        };
      
        addToBoxBtn.addEventListener('click', handleClick);
        this.eventListeners.set(addToBoxBtn, handleClick);
      }

      // addSubscriptionToCart(addToBoxBtn) {
      //   addToBoxBtn.addEventListener('click', async () => {
      //     console.log("hello there")
      //     let items = [
      //       {
      //         'id': this.planVariantId,
      //         'quantity': 1,
      //         'selling_plan': this.sellingPlanId,
      //         'properties': this.subscriptionData
      //       }
      //     ];
          
      //     if (this.selectedExtraProductIds && this.selectedExtraProductIds.size > 0) {
      //       this.selectedExtraProductIds.forEach((id) => {
      //         items.push({
      //           'id': id,
      //           'quantity': 1
      //         });
      //       });
      //     }
    
      //     let giftProduct = this.querySelector('.js-sub-free-gift');
      //     if (giftProduct && this.addGift == "true") {
      //       let giftProductId = giftProduct.getAttribute('data-gift-id');
      //       if (giftProductId) {
      //         items.push({
      //           'id': giftProductId,
      //           'quantity': 1,
      //           'properties': {
      //             '_subscription_free_gift': 'true'
      //           }
      //         });
      //       }
      //     }
    
      //     let formData = { 'items': items };
    
      //     fetch(window.Shopify.routes.root + 'cart/add.js', {
      //       method: 'POST',
      //       headers: {
      //         'Content-Type': 'application/json'
      //       },
      //       body: JSON.stringify(formData)
      //     })
      //     .then(response => response.json())
      //     .then(data => {
      //       window.location.href = "/cart";
      //     })
      //     .catch(error => console.error('Error adding to cart:', error));
      //   });
      // }
      
    }
  );
}
